// extracted by mini-css-extract-plugin
export default {"viewBox":"UserHelp_viewBox__dZS+l"};